import { useEffect, useState } from 'react';
import { LatLng } from 'react-native-maps';
import { getDistanceFromLatLonInMeters } from 'utils/mapUtils';

/**
 * Follows the given location, but only moves to a new one when it is more than `thresholdInMeters`
 * away from the one it is on. Use it where small GPS changes should not redo work, such as sorting
 * a list or fetching nearby zones.
 */
const useStableLocation = (
  location: LatLng | null,
  thresholdInMeters = 100
): LatLng | null => {
  const [stableLocation, setStableLocation] = useState<LatLng | null>(location);

  useEffect(() => {
    setStableLocation((previous) => {
      if (!location) {
        return previous;
      }
      if (!previous) {
        return location;
      }
      return getDistanceFromLatLonInMeters(location, previous) >
        thresholdInMeters
        ? location
        : previous;
    });
  }, [location, thresholdInMeters]);

  return stableLocation;
};

export default useStableLocation;
